<template>
    <div class="continueToForm">
        <p class="user">-> Weiter zum Kontaktformular? [J/N]  </p>
        <!--p class="user">{{ commandHead }}</p---->
        <input 
        v-if="screenWidth>600"
        ref="textField"
        @keyup.enter="sendEmit"
        > 
        <!--"emit('continue', messagee)"/-->
      <div id="choiceButtons" v-if="screenWidth<600">
        <input class="button" type="button" v-if="noContinue==false" @click="sendEmit" ref="message" value="J"/>
        <input class="button" type="button" @click="noContinue=true" value="N"/>
      </div>
    </div>
</template>
  
  
<script>
  import { ref } from 'vue';


  export default {
    emits: ['continue', 'focus'],
    props: {
      screenWidth: Number,
    },
    setup(){
      const textField = ref(0);
      const noContinue = ref(false);
     // const emit = defineEmits([['continue']])

      return{
        textField,
        noContinue,
      }
    },

  updated(){
    this.focusInput();
  },
  methods: {
    focusInput(){
      this.$refs.textField('focus');
    },
    sendEmit(textInput){
     this.$emit('continue', textInput);
    }
  },
}
</script>
  
  
<style scoped>
  p{
  }
  .continueToForm{
    text-align: left;
    display:flex;
    gap: 1rem;
  }
  input{
    background-color: transparent;
    outline: none;
    color: #0f0f;
    border: none;
    font-size:1.5rem;
  }
  #choiceButtons{
    display:flex;
    align-items:center;
    width:10rem;

  }
  .button{
    font-size: 1rem;
    width:4rem;
    height:2rem;
    border: 2px solid;
    border-color:black;
    color:black;
    background-color: #0f0f;
  }
</style>